import NextImage from "@/components/global/NextImage";
import Link from "next/link";

const FooterPayments = ({ isResponsive = false }) => {
  return (
    <div
      className={`w-11/12 mx-auto ${
        isResponsive ? "block md:hidden" : "hidden md:block"
      }`}
    >
      <div className="flex flex-wrap items-center justify-center gap-4 pt-2 lg:justify-between lg:pt-7">
        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 sm:gap-3 lg:justify-start">
          <NextImage
            width={64}
            height={32}
            loading="lazy"
            src="/imgs/payments/mada.png"
            className="object-contain max-[768px]:w-10 max-[768px]:h-8 w-16 h-8"
            alt="tasaheel"
          />
          <NextImage
            width={64}
            height={32}
            loading="lazy"
            src="/imgs/payments/tasaheel.png"
            className="object-contain max-[768px]:w-10 max-[768px]:h-8 w-16 h-8"
            alt="tasaheel"
          />
          <NextImage
            width={64}
            height={32}
            loading="lazy"
            src="/imgs/payments/tabby_installments.png"
            className="object-contain max-[768px]:w-10 max-[768px]:h-8 w-16 h-8"
            alt="tabby_installments"
          />
          <NextImage
            width={64}
            height={32}
            loading="lazy"
            src="/imgs/payments/new_tamara_pay_by_instalments_4.png"
            className="object-contain max-[768px]:w-10 max-[768px]:h-8 w-16 h-8"
            alt="new_tamara_pay_by_instalments_4"
          />
          <NextImage
            width={64}
            height={32}
            loading="lazy"
            src="/imgs/payments/visa.png"
            className="object-contain max-[768px]:w-10 max-[768px]:h-8 w-16 h-8"
            alt="visa"
          />
          <NextImage
            width={64}
            height={32}
            loading="lazy"
            src="/imgs/payments/installment.png"
            className="object-contain max-[768px]:w-10 max-[768px]:h-5 w-16 h-[26px] px-2 rounded-lg bg-white"
            alt="visa"
          />

          <NextImage
            width={64}
            height={32}
            loading="lazy"
            src="/imgs/payments/cod.png"
            className="object-contain max-[768px]:w-10 max-[768px]:h-8 w-16 h-8"
            alt="cod"
          />
        </div>

        <div className="flex items-center gap-2 mx-auto sm:mx-0">
          <Link
            prefetch={false}
            className="relative block w-16 overflow-hidden max-sm:w-9 aspect-square"
            href="/pdfs/4030127263-CR.pdf"
            target="_blank"
          >
            <NextImage
              fill
              loading="lazy"
              src="/imgs/Qr.png"
              className="object-contain max-sm:size-8 size-10"
              alt="Qr"
            />
          </Link>
          <div className="relative block w-16 overflow-hidden max-sm:w-9 aspect-square">
            <NextImage
              fill
              loading="lazy"
              src="/imgs/Percentage.png"
              className="object-contain max-sm:size-8 size-10"
              alt="Percentage"
            />
          </div>
          <Link
            className="relative block w-16 overflow-hidden max-sm:w-9 aspect-square"
            prefetch={false}
            href="/pdfs/VAT.pdf"
            target="_blank"
          >
            <NextImage
              fill
              loading="lazy"
              src="/imgs/vat.svg"
              className="object-contain max-sm:size-8 size-10"
              alt="Tax"
            />
          </Link>
          <Link
            prefetch={false}
            href="https://maroof.sa/businesses/details/244240"
            target="_blank"
            className="relative block w-16 overflow-hidden max-sm:w-9 aspect-square"
          >
            <NextImage
              fill
              loading="lazy"
              src="/imgs/Maarouf.png"
              className="object-contain max-sm:size-8 size-10"
              alt="Maarouf"
            />
          </Link>
          <Link
            prefetch={false}
            href="https://qr.mc.gov.sa/sales/license-details?qr=nY/aIvecMG+YSCtQ9aOaJg=="
            target="_blank"
            className="relative block w-16 overflow-hidden max-sm:w-9 aspect-square"
          >
            <NextImage
              fill
              loading="lazy"
              src="/imgs/sbc.png"
              className="object-contain max-sm:size-8 size-10"
              alt="Maarouf"
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FooterPayments;
